import React, { FC, useEffect } from "react";
import { shallowEqual } from "react-redux";
import { useAppDispatch } from "../../store/hooks/dispatch.hook";
import { useAppSelector } from "../../store/hooks/selector.hook";
import { getAdditionalListFetch } from "../../store/state/services/upsells/upsells.slice";
import { SYSTEM_ADMIN_ID } from "../../common/constants/role";
import { culcPage } from "../../common/helpers/culcPage";
import { Filter } from "../../common/models/Filters";

function withLoadingUpsells(Component: React.ComponentType) {
    const ComponentWithLoadingUpsells: FC = () => {
        const dispatch = useAppDispatch();

        const page = useAppSelector(state => state.upsellsServices.page, shallowEqual);
        const totalCount = useAppSelector(state => state.upsellsServices.totalCount, shallowEqual);
        const pageAll = useAppSelector(state => state.upsellsServices.pageAll, shallowEqual);
        const pageSize = useAppSelector(state => state.upsellsServices.pageSize, shallowEqual);
        const getAllItems = useAppSelector(state => state.upsellsServices.getAllItems, shallowEqual);
        const pagesRange = culcPage(page, pageAll, totalCount, pageSize);

        const vendorId = useAppSelector(state => state.user.vendorId, shallowEqual) || -1;
        const roleId = useAppSelector(state => state.user.roleId, shallowEqual) || -1;

        const active = useAppSelector(state => state.upsellsServices.filter.active, shallowEqual);

        useEffect(() => {
            if (roleId > SYSTEM_ADMIN_ID) {
                let filter: Filter = { active };

                if (!getAllItems) {
                    filter.range = {
                        from: pagesRange.from,
                        to: pagesRange.to
                    }
                }

                dispatch(getAdditionalListFetch({ vendorId, filter }));
            }
        }, [vendorId, roleId]);

        return (
            <Component />
        );
    }

    return ComponentWithLoadingUpsells;
}

export default withLoadingUpsells;